/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import MaterialTable from 'material-table';
import React, { useEffect } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Popup from '../../../Base/views/Popup';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { GetObjectCommand } from "@aws-sdk/client-s3";
import { toast } from "react-toastify";
import { s3Client } from "../../../Base/helper/baseFunctions";
import ConfirmationDialog from '../../../Base/views/ConfirmationDialog';
import { useState } from 'react';
import IdentityProofModal from './IdentityProofModal';
import { useDispatch, useSelector } from "react-redux";
import { DeleteEmployeePersonalAction, GetEmployeePersonalAction } from '../../../../../store/Employee/Personal/Action';
import { getUserData } from '../../../Base/helper/baseFunctions';
import { sendOnboardRequestMessageHelper } from '../../../Whatsapp/helper/TemplateHelper';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const IdentityProof = ({  disableEdit, OnboardingEmpData, newdata,currentMode}) => {
    const initialValues = {
        proof_type: "",
        name: "",
        number: "",
        surname: "",
        givenname: "",
        issued_place: "",
        expiry_date: null,
        proof: ""
    }
    const userData = getUserData()
    const dispatch = useDispatch();
    const [editedRecord, setEditedRecord] = useState(null);
    const [openPopup, setOpenPopup] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [currentData, setCurrentData] = useState({});
    const [anchorEl, setAnchorEl] = useState(null);
    const openMoreVertIcon = Boolean(anchorEl);

    const { personalDatas } = useSelector(state => state.EmployeeReducer.EmployeePersonalReducer);
    useEffect(() => {
        if (currentMode ==="editemployee" && OnboardingEmpData) {
            dispatch(GetEmployeePersonalAction({ domain: userData?.domain, employee_id: OnboardingEmpData?.employee_id }));
        } 
        else if(currentMode ==="addemployee"){
            dispatch(GetEmployeePersonalAction({ domain: userData?.domain, employee_id: newdata?.employee_id }));
        }
        else {
            dispatch(GetEmployeePersonalAction({ domain: userData?.domain, employee_id: userData?.employee_id }));
        }

    }, [!personalDatas])


    const handleMoreVertIconClick = (event, row) => {
        setCurrentData(row)
        setAnchorEl(event.currentTarget);
    };
    const handleConfirmDelete = (rowData) => {
        setAnchorEl(false);
        setOpenDialog(true);
        setCurrentData(rowData)
    };
    
      const handleView = async (event, rowData) => {
        event.stopPropagation();
        let filename = rowData?.proof;
        const bucketParams = {
          Bucket: process.env.REACT_APP_DO_BUCKET_NAME,
          Key: filename,
        };
        try {
          const url = await getSignedUrl(
            s3Client,
            new GetObjectCommand(bucketParams),
            { expiresIn: 3 * 60 }
          );
          window.open(url, "_blank");
          return url;
        } catch (err) {
          toast.error(err);
        }
      };

    const handleAdd = () => {
        if (currentMode ==="editemployee" && OnboardingEmpData) {
            setEditedRecord({ ...initialValues, domain: userData?.domain, employee_id: OnboardingEmpData?.employee_id })
        } 
        else if(currentMode ==="addemployee"){
            setEditedRecord({ ...initialValues, domain: userData?.domain, employee_id: newdata?.employee_id })
        }
        else {
            setEditedRecord({ ...initialValues, domain: userData?.domain, employee_id: userData?.employee_id })
        }
        setOpenPopup(true);
    };

    const handleEdit = (rowData) => {
        setAnchorEl(false);
        if (currentMode ==="editemployee" && OnboardingEmpData) {
            setEditedRecord({ ...rowData, domain: userData?.domain, employee_id: OnboardingEmpData?.employee_id })
        }
        else if(currentMode ==="addemployee"){
            setEditedRecord({ ...rowData, domain: userData?.domain, employee_id: newdata?.employee_id })
        } 
        else {
            setEditedRecord({ ...rowData, domain: userData?.domain, employee_id: userData?.employee_id })
        }
        setOpenPopup(true);
    };

    const handleDelete = () => {
        setOpenDialog(false);
        var id = [];
        if (Array.isArray(currentData)) {
            currentData.forEach(item => {
                id.push(item.emp_idproof_id);
            })
            if(currentMode ==="addemployee"){
                dispatch(DeleteEmployeePersonalAction({ emp_idproof_id: `{${id}}`, employee_id: newdata?.employee_id }))
            }
            else{
                dispatch(DeleteEmployeePersonalAction({ emp_idproof_id: `{${id}}`, employee_id: OnboardingEmpData?.employee_id ? OnboardingEmpData?.employee_id : userData?.employee_id }))
            }
        } 
        else if(currentMode ==="addemployee"){
            dispatch(DeleteEmployeePersonalAction({ emp_idproof_id: `{${currentData?.emp_idproof_id}}`, employee_id: newdata?.employee_id }))
        }
        else {
            dispatch(DeleteEmployeePersonalAction({ emp_idproof_id: `{${currentData?.emp_idproof_id}}`, employee_id: OnboardingEmpData?.employee_id ? OnboardingEmpData?.employee_id : userData?.employee_id }))
        }
    };

    const handleBulkDelete = (selectedRow) => {
        setCurrentData(selectedRow);
    };

    const handleMoreVertIconClose = () => {
        setAnchorEl(null);
    };

    const addMode = (resetForm) => {
        resetForm();
        setEditedRecord(null);
        setOpenPopup(false);
    };
    const addButton = <Button onClick={handleAdd} variant="contained" startIcon={<AddIcon />} className="mpl-primary-btn" >Add</Button> 
    

    return (
        <Box>
            <MaterialTable
                columns={[
                    { title: "Proof Type", field: "identity_name", cellStyle: { padding: "0px" } },
                    { title: "Name", field: "name", cellStyle: { padding: "0px" } },
                    {
                        title: "Number", field: "number", cellStyle: { padding: "0px" }, render: rowData => {
                            return (rowData?.number && OnboardingEmpData) ? "*********" + rowData?.number.substr(rowData?.number.length - 4) : rowData?.number && !OnboardingEmpData ? rowData?.number : ""
                        }
                    },
                    {
                        title:"Document",
                        render: rowData => (
                            <div>
                                {rowData.proof ? (
                                    <IconButton
                                        onClick={(event) => handleView(event,rowData)}
                                    >
                                        <VisibilityIcon />
                                    </IconButton>
                                ):(
                                    <IconButton disabled>
                                        <VisibilityOffIcon />
                                    </IconButton>
                                )}
                            </div>
                        ),
                        cellStyle: { padding: "0px", justifyContent:"right" }
                    }
                ]}
                data={personalDatas ? personalDatas : []}
                onSelectionChange={(selectedRow) => handleBulkDelete(selectedRow)}
                options={{
                    maxBodyHeight: OnboardingEmpData ? "44vh" : "52vh",
                    minBodyHeight: OnboardingEmpData ? "44vh" : "52vh",
                    rowStyle: { fontSize: "13px" },
                    headerStyle: { padding: "0px", fontWeight: "bold", paddingRight: "10px" },
                    sorting: true,
                    search: true,
                    searchText: "",
                    searchFieldAlignment: "right",
                    searchAutoFocus: true,
                    searchFieldVariant: "standard",
                    filtering: false,
                    paging: true,
                    pageSizeOptions: [25, 50],
                    pageSize: 25,
                    paginationType: "stepped",
                    showFirstLastPageButtons: false,
                    paginationPosition: "bottom",
                    exportButton: true,
                    exportAllData: true,
                    exportFileName: "Identity Proof",
                    addRowPosition: "first",
                    selection: disableEdit ? false : true,
                    actionsColumnIndex: -1,
                    showSelectAllCheckbox: true,
                    showTextRowsSelected: true,
                    grouping: false,
                    columnsButton: true,
                }}
                
                actions={[
                    !disableEdit && currentMode === "editemployee" && 
                    ['cvtmeepl', "adobemeepl"].includes(userData?.domain) &&
                    {
                        icon: () => <WhatsAppIcon />,
                        tooltip: OnboardingEmpData?.whatsapp_phone_no? 'Send WhatsApp Request'
                         : "WhatsApp number not available",
                        isFreeAction: true,
                        disabled: !OnboardingEmpData?.whatsapp_phone_no,
                        onClick: () => sendOnboardRequestMessageHelper(
                            {
                                emp_id: OnboardingEmpData?.employee_id,
                                message: "Share your Identity Proof details",
                                info_type: "identity-info",
                                number: OnboardingEmpData?.whatsapp_phone_no
                            })
                    },
                    !disableEdit && {
                        icon: () => <MoreVertIcon />,
                        position: "row",
                        tooltip: "Setting",
                        onClick: (_event, rowData) => handleMoreVertIconClick(_event, rowData),
                    },
                    !disableEdit && {
                        icon: () => <IconButton sx={{ padding: "0px" }}><DeleteIcon /></IconButton>,
                        tooltip: "Delete",
                        onClick: (_event, rowData) => { handleConfirmDelete(rowData) },
                    },
                ]}
                title={disableEdit ? "" : addButton}
            />
            <Popup
                title={editedRecord?.emp_idproof_id ? "Edit Identity Proof" : "Add Identity Proof"}
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
                isMasterProduct={true}
            >
                <IdentityProofModal
                    editedRecord={editedRecord}
                    addMode={addMode}
                    setOpenPopup={setOpenPopup}
                    setEditedRecord={setEditedRecord}
                />
            </Popup>
            <ConfirmationDialog
                title="Do you wish to proceed?"
                openDialog={openDialog}
                closeDialog={setOpenDialog}
                popupTitle="Identity Proof"
                OkButtonText="OK"
                onSubmit={handleDelete}
            />
            {
                
                <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    open={openMoreVertIcon}
                    onClose={handleMoreVertIconClose}
                >
                    {
                        
                        <MenuItem key="edit" onClick={() => (handleEdit(currentData))}>
                            <EditIcon sx={{ fontSize: "15px" }} /> &nbsp; <Typography sx={{ fontSize: "15px" }}>Edit</Typography>
                        </MenuItem>
                    }
                    <MenuItem key="delete" onClick={() => (handleConfirmDelete(currentData))}>
                        <DeleteIcon sx={{ fontSize: "15px" }} /> &nbsp; <Typography sx={{ fontSize: "15px" }}>Delete</Typography>
                    </MenuItem>
                </Menu>
            }
        </Box>
    );
};

export default IdentityProof;